'use strict';

import Async from 'async';
import _ from 'lodash';

export default class UserModalController {
  /*@ngInject*/
  constructor($http, $q, $timeout, $uibModalInstance, user) {
    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$uibModalInstance = $uibModalInstance;

    this.user = user;

    this.isAdd = true;
    this.roleOptions = [ 'admin', 'user'];
    this.exportOptions = [ 'Yes', 'No'];
    this.systemOptions = [];
    this.form = {};
    this.submitted = false;
    this.isSaving = false;
    this.errors;
  }

  // getSystems() {
  //   let deferred = this.$q.defer();
  //   let self = this;
  //   this.$http.get(`/api/types/systems?_pageSize=All&_selector=name`)
  //     .then(function(response) {
  //       self.systemOptions = response.data;
  //       deferred.resolve();
  //     }, function(err) {
  //       deferred.resolve();
  //     });
  //   return deferred.promise;
  // }

  getData(id) {
    let self = this;
    this.$http.get(`/api/users/${id}`)
      .then(function(response) {
        response.data.canExportOrders = response.data.canExportOrders ? 'Yes' : 'No';
        self.form = response.data;
      }, function(err) {

      });
  }

  update(form, id, payload) {
    let self = this;
    this.$http.put(`/api/users/${id}`, payload)
      .then(function(response) {
        self.$uibModalInstance.close();
      }, function(err) {
        self.isSaving = false;
        // Update validity of form fields that match the mongoose errors
        self.errors = {};
        angular.forEach(err.data.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          self.errors[field] = error.message;
        });
      });
  }

  create(form, payload) {
    let self = this;
    this.$http.post('/api/users', payload)
      .then(function(response) {
        self.$uibModalInstance.close();
      }, function(err) {
        self.isSaving = false;
        // Update validity of form fields that match the mongoose errors
        self.errors = {};
        angular.forEach(err.data.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          self.errors[field] = error.message;
        });
      });
  }

  submitForm(form) {
    if(form.$valid) {
      let self = this;
      this.submitted = true;
      this.isSaving = true;
      let payload = {
        name: this.form.name,
        email: this.form.email,
        role: this.form.role,
        canExportOrders: this.form.canExportOrders === 'Yes' ? true : false
      };
      // if(this.form.role === 'user') {
      //   payload.system = this.form.system;
      // }
      if(this.user && this.user._id) {
        this.update(form, this.user._id, payload);
      } else {
        payload.password = this.form.confirmPassword;
        self.create(form, payload);
      }
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  $onInit() {
    let self = this;
    // this.getSystems().then(function() {
      if(self.user && self.user._id) {
        self.isAdd = false;
        self.getData(self.user._id);
      } else {
        self.form = {
          role: 'user',
          canExportOrders: 'No'
        };
      }
    // });
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/user.modal.controller.js